module.exports = __webpack_public_path__ + "img/295.c8ee6ed5.jpg";